import React from 'react';
import { Link } from 'react-router-dom';
import ethosboardLogo from '../../assets/images/ethoslogo.png';
import ethosboardIcon from '../../assets/images/ethosboard_icon.png';

const ETHOSBOARD_SITE = 'https://ethosboard.com/';

const LandingLogo = ({
  to = '/',
  variant = 'light',
  layout = 'lockup',
  showProductName = false,
  showParentLink = false,
  size = 'md',
  className = '',
}) => {
  const isOnDark = variant === 'dark';
  const heights = { sm: 28, md: 36, lg: 48 };
  const logoHeight = heights[size] || heights.md;
  const useIcon = layout === 'logo-only';
  const imageSrc = useIcon ? ethosboardIcon : ethosboardLogo;

  const productBlock = showProductName && (
    <div className="landing-brand-product min-w-0">
      <p
        className={`landing-brand-product-name mb-0 ${
          size === 'lg' ? 'fs-4' : size === 'sm' ? 'fs-6' : 'fs-5'
        } ${isOnDark ? 'text-white' : 'text-dark'}`}
      >
        Ethosboard
      </p>
    </div>
  );

  const logoImage = (
    <img
      src={imageSrc}
      alt="Ethosboard"
      className="landing-brand-logo-img object-contain"
      style={{
        height: logoHeight,
        width: 'auto',
        maxWidth: useIcon ? logoHeight * 1.15 : size === 'lg' ? 240 : 200,
      }}
    />
  );

  const content =
    layout === 'logo-only' ? (
      <div className={`landing-brand-logo-only ${className}`}>{logoImage}</div>
    ) : (
      <div className={`landing-brand-lockup ${isOnDark ? 'landing-brand-on-dark' : ''} ${className}`}>
        <div className="landing-brand-parent shrink-0">
          {showParentLink ? (
            <a
              href={ETHOSBOARD_SITE}
              target="_blank"
              rel="noopener noreferrer"
              className="text-decoration-none d-inline-block"
              aria-label="Ethosboard"
              onClick={(e) => e.stopPropagation()}
            >
              {logoImage}
            </a>
          ) : (
            logoImage
          )}
          {showParentLink && (
            <span className={`landing-brand-parent-label ${isOnDark ? 'text-white-50' : 'text-secondary'}`}>
              Ethosboard
            </span>
          )}
        </div>

        {showProductName && (
          <>
            <span className={`landing-brand-divider ${isOnDark ? 'landing-brand-divider-dark' : ''}`} aria-hidden="true" />
            {productBlock}
          </>
        )}
      </div>
    );

  if (to) {
    return (
      <Link to={to} className="landing-brand-link no-underline" aria-label="Ethosboard home">
        {content}
      </Link>
    );
  }

  return content;
};

export default LandingLogo;
